import { createAsyncThunk } from '@reduxjs/toolkit'
import { ApiError } from '@user/store/agreements/typings'
import {
  OverdueNextActionDatesInput,
  OverdueNextActionDatesData,
} from './typings'
import { get, post } from '@user/store/services/crud'
import { objectToQueryString } from '@sales-center/common'
import { ServiceConfig } from '@user/store/services/config'
import { IUserPreferenceDashboard } from '@user/store/userPreferences/typings'

export const getData = createAsyncThunk<
  OverdueNextActionDatesData,
  OverdueNextActionDatesInput,
  { rejectValue: ApiError }
>('dashboard/overdueNextActionDates/getData', async (params, thunkApi) => {
  const response = await get(
    `${ServiceConfig.baseAPIUrl}/Dashboard/overdue?${objectToQueryString(
      params,
    )}`,
  )

  if (response.ok) {
    const payload: OverdueNextActionDatesData = await response.json()
    return payload
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})

export const postData = createAsyncThunk<
  IUserPreferenceDashboard,
  OverdueNextActionDatesInput
>(
  'usersPreferences/Dashboard/overdueNextActionDates/post',
  async (userPref, thunkApi) => {
    const response = await post(
      `${ServiceConfig.baseAPIUrl}/UserPreferences/dashboard`,
      userPref,
    )
    if (response.ok) {
      const result: IUserPreferenceDashboard = await response.json()
      return result
    }
    return thunkApi.rejectWithValue(await response.json())
  },
)
